// Module
var code = `<div class="date-picker-container">
  <div class="date-input" id="input">
    <div class="date-text"></div>
    <svg class="chevron-icon \${this.isOpen ? 'open' : ''}" viewBox="0 0 20 20" fill="none">
      <path d="M10 13.062L5 8.062L6.062 7L10 10.938L13.938 7L15 8.062L10 13.062Z" fill="#293050"/>
    </svg>
  </div>
  
  <div class="popup" id="popup">
    <div class="sidebar">
      <div>
        <div class="quick-option" data-action="today">Today</div>
        <div class="quick-option" data-action="yesterday">Yesterday</div>
        <div class="quick-option" data-action="lastweek">Last week</div>
        <div class="quick-option" data-action="lastmonth">Last month</div>
        <div class="quick-option" data-action="lastquarter">Last quarter</div>
      </div>
      <button class="reset-btn" id="reset">Reset</button>
    </div>
    
    <div class="calendar">
      <div class="calendar-header">
        <div class="month-year"></div>
        <div class="nav-buttons">
          <button class="nav-btn" id="prev-month">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12 15L7 10L12 5L13.062 6.062L9.125 10L13.062 13.938L12 15Z" fill="#293050"/>
            </svg>
          </button>
          <button class="nav-btn" id="next-month">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M8 15L6.938 13.938L10.875 10L6.938 6.062L8 5L13 10L8 15Z" fill="#293050"/>
            </svg>
          </button>
        </div>
      </div>
      
      <div class="weekdays">
      </div>
      
      <div class="days-grid">
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;